import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { DotsThreeVertical, Copy, Trash, Bug } from "@phosphor-icons/react";

// Kebab (⋮) menu that sits on every dashboard card (project or folder).
// Spec: Report an Issue · Duplicate · Delete. `canDelete` gates the destructive action.
export default function ProjectCardMenu({
  testidSuffix,
  canDelete = true,
  canDuplicate = true,
  onReportIssue,
  onDuplicate,
  onDelete,
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          className="h-7 w-7 rounded-md hover:bg-slate-100 text-slate-400 hover:text-slate-950 flex items-center justify-center transition-colors"
          title="More actions"
          data-testid={`card-menu-${testidSuffix}`}
        >
          <DotsThreeVertical size={16} weight="bold" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="rounded-md w-[180px]"
        onClick={(e) => e.stopPropagation()}
      >
        {canDuplicate && (
          <DropdownMenuItem
            onClick={(e) => { e.stopPropagation(); onDuplicate?.(); }}
            className="text-xs"
            data-testid={`card-menu-duplicate-${testidSuffix}`}
          >
            <Copy size={12} weight="bold" className="mr-2" />
            Duplicate
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onClick={(e) => { e.stopPropagation(); onReportIssue?.(); }}
          className="text-xs"
          data-testid={`card-menu-report-${testidSuffix}`}
        >
          <Bug size={12} weight="bold" className="mr-2" />
          Report an issue
        </DropdownMenuItem>
        {canDelete && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={(e) => { e.stopPropagation(); onDelete?.(); }}
              className="text-xs text-red-600 focus:text-red-600"
              data-testid={`card-menu-delete-${testidSuffix}`}
            >
              <Trash size={12} weight="bold" className="mr-2" />
              Delete
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
